module.exports = __webpack_public_path__ + "img/upload.69305c3d.svg";